import { useLocalStorage } from '@vueuse/core';
import { computed } from 'vue';
import { ViewMode } from '@/core/types/components/helps';

export type UserPreferences = {
  objectPageViewMode?: ViewMode;
  legalPageViewMode?: ViewMode;
  usersPageViewMode?: ViewMode;
  controlledTariffsPageViewMode?: ViewMode;
  tariffsRemotePageViewMode?: ViewMode;
};

const userPreferences = useLocalStorage<UserPreferences>('userPreferences', {});

export const useUserPreference = <K extends keyof UserPreferences>(
  key: K,
  defaultValue: Required<UserPreferences>[K],
) => {
  const getUserPreference = (key: K) => {
    return userPreferences.value[key] || defaultValue;
  };

  const setUserPreference = <K extends keyof UserPreferences>(key: K, value: UserPreferences[K]) => {
    userPreferences.value[key] = value;
  };

  return computed({
    get: () => getUserPreference(key),
    set: (value) => setUserPreference(key, value),
  });
};
